<template>
  <svg :class="svgClass" aria-hidden="true" :style="getStyle">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    className: {
      default: '',
      type: String
    },
    iconClass: {
      required: true,
      type: String
    },
    size: {
      required: false,
      type: Number
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`;
    },
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className;
      } else {
        return 'svg-icon';
      }
    },
    getStyle() {
      if (this.size) {
        return 'height:' + this.size + 'rem;width:' + this.size + 'rem;';
      }
      return '';
    }
  },
  created() {
    import('@/assets/svg/' + this.iconClass + '.svg');
  },
  methods: {}
};
</script>

<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
